import BusinessIcon from "assets/icons/invoice/BusinessIcon";
import InvoiceIcon from "assets/icons/invoice/InvoiceIcon";
import TableIcon from "assets/icons/invoice/TableIcon";
import UserIcon from "assets/icons/invoice/UserIcon";

export default [
  {
    icon: BusinessIcon,
    title: "اطلاعات فروشنده",
    subItems: [
      {
        title: "نام فروشنده",
        name: "businessName",
        input: true,
      },
      {
        title: "آدرس",
        name: "address",
        input: true,
      },
      {
        title: "تلفن",
        name: "telephone",
        input: true,
      },
      {
        title: "همراه",
        name: "mobile",
        input: false,
      },
    ],
  },
  {
    icon: UserIcon,
    title: "اطلاعات خریدار",
    subItems: [
      {
        title: "نام خریدار",
        name: "cutomerBusinessNameActive",
        input: false,
      },
      {
        title: "آدرس",
        name: "customerAddress",
        input: true,
      },
      {
        title: "تلفن",
        name: "customerTelephone",
        input: true,
      },
      {
        title: "همراه",
        name: "customerMobile",
        input: false,
      },
    ],
  },
  {
    icon: InvoiceIcon,
    title: "اطلاعات فاکتور",
    subItems: [
      {
        title: "شماره فاکتور",
        name: "showAccountingCode",
        input: false,
      },
      {
        title: "تاریخ صدور",
        name: "showDate",
        input: false,
      },
      {
        title: "ساعت صدور",
        name: "showTime",
        input: false,
      },
      {
        title: "تاریخ سررسید",
        name: "showDueDate",
        input: false,
      },
      {
        title: "ارجاع",
        name: "showReference",
        input: false,
      },
      {
        title: "نمایش مبلغ پرداخت شده",
        name: "showPaymentPrice",
        input: false
      },
      {
        title: "نمایش تراز شخص",
        name: "showBalancePrice",
        input: false
      },
      {
        title: "نمایش لوگو چرتکه",
        name: "showChortkeLogo",
        input: false,
      },
      {
        title: "نمایش جمع مالیات",
        name: "activeSumTax",
        input: false,
      },
      {
        title: "نمایش جمع تخفیفات",
        name: "activeSumDiscount",
        input: false,
      },
      {
        title: "نمایش جمع مقدار",
        name: "activeSumQuantity",
        input: false,
      },
    ],
  },
  {
    icon: TableIcon,
    title: "جدول کالا/خدمات",
    subItems: [
      {
        title: "نمایش کد کالا",
        name: "showProductcode",
        input: false,
      },
      {
        title: "نمایش توضیحات",
        name: "showProductDescription",
        input: false,
      },
      {
        title: "نمایش تخفیف",
        name: "showDiscount",
        input: false,
      },
      {
        title: "نمایش مالیات",
        name: "showTax",
        input: false,
      },
    ],
  },
];
